import { yupResolver } from '@hookform/resolvers/yup'
import { useTranslation } from 'react-i18next'
import * as yup from 'yup'

export const useTextValidationSchema = () => {
	const { t } = useTranslation()

	const textSchema = yup.object({
		textLayerValue: yup.string().required(t('This field is required'))
	})

	return yupResolver(textSchema)
}
